import React from 'react'
import classNames from 'classnames'

import FieldValidationMessage from '../field-validation-message/index.jsx'

import './styles.scss'

const ValidatedForm = ({ className, inputs }) => {
  return (
    <div className={classNames('validated-form', className)}>
      {inputs.map(
        ({ label, render, required, show = true, validationClassName }) =>
          show && (
            <div key={label} className="validated-form__row">
              <div className="validated-form__column">
                <div className="validated-form__row">{render()}</div>
                <FieldValidationMessage
                  fieldName={label}
                  className={validationClassName}
                  required={required}
                />
              </div>
            </div>
          )
      )}
    </div>
  )
}

export default ValidatedForm
